<template>
    <div class="progress-box">
        <div class="progress">
            <div class="bg">
                <div class="val" :style="'width: '+ progressVal +'%'"></div>
            </div>
            <!--vant组件渲染的时候会存在计算长度有问题的情况。-->
<!--            <Progress-->
<!--                style="flex: 1"-->
<!--                :show-pivot="false"-->
<!--                color="#F84025"-->
<!--                :percentage="parseInt((index[index.length - 1]/total)*100)"-->
<!--            />-->
<!--            <div class="val van-ellipsis">-->
<!--                {{ currentTopicNumber }}/{{ total }}-->
<!--            </div>-->
        </div>
    </div>
</template>

<script>
    //import {Progress} from 'vant'
    export default {
        name: 'TopicProgress',
        props: {
            total: {
                type:Number,
                default:0,
            },
            index:{
                type:Number,
                default:0,
            }
        },

        computed: {
            progressVal: function () {
                if(0 === this.total)return 0;
                let val = parseInt(this.index) + 1;
                if(val >= this.total){return 100}
                return parseInt(val / this.total * 100);
            },
        },
        components: {}
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .progress-box{
        width: 100%;
        min-height: 13px;
        overflow: hidden;
        .progress{
            background: #fff;
            position: fixed;
            display: flex;
            left: 0;
            top: 44px;
            right: 0;
            overflow: hidden;
            padding: 2px 15px;
            align-items: center;
            z-index: 10;
            .bg{
                background: #EEEEEE;
                width: 100%;
                height: 6px;
                border-radius: 3px;
                .val{
                    background:linear-gradient(0deg,rgba(255,68,68,1) 0%,rgba(255,63,90,1) 100%);
                    height: 6px;
                    border-radius: 3px;
                }
            }
            /*.val{*/
            /*    text-align: right;*/
            /*    width: 80px;*/
            /*    margin-left: 13px;*/
            /*    font-size: 12px;*/
            /*    color: #222;*/
            /*}*/
        }
    }

</style>
